import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';

import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {CONFIG} from "../../../app/config";
import {TAction} from "../../../app/enum";
import {LogadoService} from "../../../providers/logado-service";
import {ProfilePagePage} from "../profile-page/profile-page";
import {ProfileService} from "../../../providers/profile-service";
import {PrivacyMenuPage} from "../privacy-menu/privacy-menu";

@Component({
    selector: 'page-visitor-menu',
    templateUrl: 'visitor-menu.html',
    providers: [ProfileService]
})
export class VisitorMenuPage {

    config: any;
    etapa: number;

    logado: any;

    rootile: any;
    visitors: any;

    constructor(public util: Util, public navCtrl: NavController, public navParams: NavParams,
                public logadoService: LogadoService, public profileService: ProfileService) {


        this.config = CONFIG;

        this.etapa = this.navParams.get('etapa');
        this.rootile = this.navParams.get('rootile');
        this.logado = this.logadoService.getAuth();

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Visitor Menu', '/visitor-menu');

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);
        if (this.etapa == 0 && !this.visitors) this.visitorLoad();

    }

    visitorLoad() {

        if (!this.logado.Profile.ProfileShip) return;


        let loading = this.util.loadingDots();
        loading.present();

        let action = (this.etapa == 0 ? TAction.acLoad : TAction.acList);
        this.profileService.visitor(action, this.rootile.Profile.ProfileID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.visitors = data.Visitors,
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    profilePage(profile) {

        let object = {profileID: profile.ProfileID};
        this.util.navActive(this.navCtrl).push(ProfilePagePage, object);

    }

    privacyMenu() {

        if (!this.rootile.Profile.ProfileZitu) return;

        let copy = this.util.deepCopy(this.rootile);

        /** 4 - MEMBERSHIP **/
        let object = {etapa: 4, rootile: this.rootile, copyile: copy};
        this.util.modalopen(PrivacyMenuPage, 'quad', true, object)
            .finally(() => this.visitorLoad())
            .subscribe();

    }

    dismiss() {

        this.navCtrl.pop({animation: 'md-transition'});
        this.util.statusBarColor(TStatusBar.sbStyleDefault);

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/visitor-menu/visitor-menu.ts